// eslint-disable-next-line import/prefer-default-export
export enum Environment {
	DEV = 'dev',
	UAT = 'uat',
	PROD = 'prod',
}
